export const mockIds = {
    package1: "pkg-001",
    package2: "pkg-002",
    module1: "mod-001",
    module2: "mod-002",
    module3: "mod-003",
    module4: "mod-004",
    user1: "usr-001",
    user2: "usr-002",
    user3: "usr-003",
    user4: "usr-004",
    user5: "usr-005",
    group1: "grp-001",
    group2: "grp-002",
    group3: "grp-003",
    word1: "wrd-001",
    word2: "wrd-002",
    word3: "wrd-003",
    word4: "wrd-004",
    word5: "wrd-005",
    word6: "wrd-006",
    levelTestGroup1: "ltg-001",
    levelTestGroup2: "ltg-002"
};
